<template>
    <div class="card-wrapper">
        <div class="card-img">
            <img :src="img" :alt="article.title" :title="article.title">
        </div>
        <div class="card-box">
            <h4 class="card-title pb-3 mbr-fonts-style display-7">
                <router-link :to="{name: 'articleById', params: {id: article.id} }" :key="article.id">{{article.title}}</router-link>
            </h4>
            <small><span class="fas fa-user"></span>&nbsp;<router-link :to="{name: 'searchByKeyword', params: {type: 'author', keyword: article.author, page:1} }">{{article.author}}&nbsp;&nbsp;</router-link><span class="fas fa-calendar"></span>&nbsp;{{article.created_at}}</small>
            <p class="mbr-text mbr-fonts-style display-7">
                {{excerpt}}...<br/><router-link :to="{name: 'articleById', params: {id: article.id} }" :key="article.id">浏览全文&nbsp;&raquo;</router-link>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "ArticleBlockIndex",
    data: function () {
        return {
            excerpt: '',
            img: '',
        };
    },
    props: [
        'article',
    ],
    methods: {
        getExcerpt() {
            this.excerpt=this.article.content.replace(/<(?:.|\n)*?>/gm, '').substring(0,100);
        }
    },
    created: function() {
        this.getExcerpt();
        this.img="http://lorempixel.com/600/400/technics/"+this.article.id%10;
        //this.img="https://picsum.photos/600/400?image="+this.article.id%17;

    }
}
</script>